import { useCallback } from 'react'
import { updateSpawnMode } from '../application/update-spawn-mode'
import type { SpawnMode } from '../domain/workflow'
import { workItems$ } from '../store'
import { workItems as workItemsPort, notify } from '../wiring'

const useUpdateSpawnMode = () => {
	const update = useCallback(async (id: string, spawnMode: SpawnMode) => {
		const updated = await updateSpawnMode(workItemsPort, id, spawnMode, notify)
		if (updated) {
			workItems$.set(workItems$.get().map(w => (w.id === updated.id ? updated : w)))
		}
		return updated
	}, [])

	return { update }
}

export { useUpdateSpawnMode }
